export enum DOCUMENT_DYNAMIC_PROPERTY_TYPE {
    BOOLEAN = 'boolean',
    MULTI_SELECT = 'multi_select',
    NUMBER = 'number',
    SELECT = 'select',
    TEXT = 'text',
}
